import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";


// Teen Patti TAble

import Teen_Patti_Table from "./components/teen_patti_table/Table";

/////////////////////////////////////////////////////////////heat Map Ends//////////////////////////////////////////////////////////////
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "./utils/IDS";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";

function App({ closeSidebar }) {

  const [urls, setUrls] = useState([]);

  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Teen_Patti_Table />,
        status: true,
      },
    ]);
  }, []);

  return (
    <>
      <section className="dashboard_layout">
        <div className="container-fluid p-0">
          <div className="layout-flex">

              <div className="content-div">
                <Routes>
                  {urls?.map(
                    (url) =>
                      url.status && (
                        <Route path={url.path} element={url.element} />
                      )
                  )}
                </Routes>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default App;
